<script setup>
import { provide, computed } from "vue";
import { useStore } from "vuex";
import PageHeader from "@/components/Dashboard/Devices/BulkDevicesUpload/PageHeader.vue";
import NotPrimaryCoursesSection from "@/components/Dashboard/Devices/BulkDevicesUpload/NotPrimaryCourses.vue";
import IncorrectDataSection from "@/components/Dashboard/Devices/BulkDevicesUpload/IncorrectData.vue";
import MissingDataSection from "@/components/Dashboard/Devices/BulkDevicesUpload/MissingData.vue";
import DuplicateDataSection from "@/components/Dashboard/Devices/BulkDevicesUpload/DuplicateData.vue";
import UploadedDevicesSection from "@/components/Dashboard/Devices/BulkDevicesUpload/UploadedDevices.vue";
import PageFooter from "@/components/Dashboard/Devices/BulkDevicesUpload/PageFooter.vue";

const store = useStore();

const bulk_upload_response = computed(
  () => store.getters["devices/getbulkUploadData"]
);
provide("bulk_upload_response", bulk_upload_response);
</script>

<template>
  <div class="mx-2">
    <PageHeader />

    <NotPrimaryCoursesSection />

    <IncorrectDataSection />

    <MissingDataSection />

    <DuplicateDataSection />

    <UploadedDevicesSection />

    <PageFooter />
  </div>
</template>

<style></style>
